// Deutsche Anzeige-Labels für Movement-Typen (backend/models.py: MovementType).
// UI-weit verwenden statt roher type-Strings (#135 Befund 9).
export const MOVEMENT_TYPE_LABELS = {
    in: "Zugang",
    out: "Entnahme",
    relocate: "Umlagerung",
    adjustment: "Korrektur",
    loan: "Ausleihe",
    return: "Rückgabe",
    disposal: "Entsorgung",
    pick: "Pickliste",
    lock: "Sperrung",
    unlock: "Entsperrung",
    maintenance_in: "In Wartung",
    maintenance_out: "Aus Wartung",
};

export function movementTypeLabel(type) {
    return MOVEMENT_TYPE_LABELS[type] || type;
}
